import { SET_TASK_FILTERS, RESET_TASK_FILTERS, SET_TASK_GRID_SORT_CRITERIA } from './actionTypes';

export const setTaskFilters = filters => ({
  type: SET_TASK_FILTERS,
  filters,
});

export const cleanTaskFilters = () => ({
  type: RESET_TASK_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_TASK_GRID_SORT_CRITERIA,
  sortCriteria,
});
